import * as React from "react";
import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import RosterTabs from "./tiles/roster/rosterTabs";
import "./styles/adminDashboard.css";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import ApplicationErrors from "./tiles/applicationErrors";
import BugReportIcon from "@mui/icons-material/BugReport";
import { useNavigate } from "react-router-dom";

interface Tile {
    key: string;
    title: string;
    description: string;
    icon: JSX.Element;
    component: JSX.Element;
}

const AdminDashboard: React.FC = () => {
    const { restrictions = [], userType } = useAppSelector((s) => s.auth);
    const [selectedSection, setSelectedSection] = useState<string | null>(null);
    const navigate = useNavigate();

    const tiles: Tile[] = [
        {
            key: "rosters",
            title: "Manage Rosters",
            description: "Upload and manage employee roster data",
            icon: <FolderSharedIcon fontSize="large" />,
            component: <RosterTabs />,
        },
        {
            key: "application-errors",
            title: "Application Errors",
            description: "View and review application errors, with monthly summary.",
            icon: <BugReportIcon fontSize="large" />,
            component: <ApplicationErrors />,
        },
    ];

    const visibleTiles = tiles.filter((tile) => !restrictions.includes(tile.key));
    const activeTile = tiles.find((tile) => tile.key === selectedSection);

    return (
        <div className="admin-dashboard-wrapper">
            <header className="admin-header-bar">
                <div className="admin-header-logo">
                    <div>
                        <h1>Admin Portal</h1>
                        <p>Manage client operations, uploads, and validations</p>
                    </div>
                </div>
            </header>

            <div className="admin-dashboard-container">
                {!selectedSection ? (
                    <div className="admin-tile-grid">
                        {visibleTiles.map((tile) => (
                            <div
                                key={tile.key}
                                className="admin-tile"
                                onClick={() => {
                                    if (tile.key === "application-errors") {
                                        navigate("/admin/application-errors");
                                    } else {
                                        setSelectedSection(tile.key);
                                    }
                                }}
                            >
                                <div className="tile-icon">{tile.icon}</div>
                                <h3 className="tile-title">{tile.title}</h3>
                                <p className="tile-description">{tile.description}</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="admin-section-container">
                        <button className="back-button" onClick={() => setSelectedSection(null)}>
                            ← Back to dashboard
                        </button>
                        {activeTile?.component}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
